import CreaSoggetto from './CreaSoggetto.md'

export default {
  creazione_soggetto: {
    title: 'Come creare un soggetto per la tua pratica?',
    content: CreaSoggetto,
    compiler: 'md'
  }
}